export default __webpack_public_path__ + "static/media/shape.59bd65b1.png";